import { useEffect, useRef } from "react";

import ListEntitiesItem from "components/ListEntitiesItem";
import ListEntitiesItemLink from "components/ListEntitiesItem/Link";
import SpacePath from "components/SpacePath";
import Box from "ds/components/Box";

import { COLUMN_GAP, COLUMN_ORDER } from "../constants";
import { WorkerPoolUsedByRow } from "../helpers";
import WorkerPoolUsedByTypeBadge from "./TypeBadge";

type WorkerPoolUsedByListItemProps = {
  item: WorkerPoolUsedByRow;
  setRowHeight?: (size: number) => void;
};

const WorkerPoolUsedByListItem = ({ item, setRowHeight }: WorkerPoolUsedByListItemProps) => {
  const rowRef = useRef<HTMLDivElement>(null);

  const handleRowHeight = () => {
    if (setRowHeight && rowRef.current) {
      setRowHeight(rowRef.current.getBoundingClientRect().height);
    }
  };

  // on every render, update the row height
  useEffect(handleRowHeight);

  return (
    <ListEntitiesItem
      direction="row"
      align="center"
      justify="between"
      grid
      gridTemplate={COLUMN_ORDER}
      gap={`0 ${COLUMN_GAP}`}
      ref={rowRef}
    >
      <Box direction="row" align="center">
        <WorkerPoolUsedByTypeBadge type={item.type} />
      </Box>

      <Box direction="row" align="center">
        <ListEntitiesItemLink href={item.href} title={item.name} />
      </Box>

      <SpacePath spaceId={item.spaceDetails.id} fallbackName={item.spaceDetails.name} />
    </ListEntitiesItem>
  );
};

export default WorkerPoolUsedByListItem;
